<template>
  <label class="form-field" :class="{ 'form-field-invalid': invalid }">
    <span v-if="label || help" class="field-label">
      <template v-if="label">{{ label }}</template>
      <HelpTip v-if="help" :text="help" />
    </span>
    <slot />
    <span v-if="error || $slots.error" class="form-field-error">
      <slot name="error">{{ error }}</slot>
    </span>
  </label>
</template>

<script>
import HelpTip from './HelpTip.vue'

export default {
  name: 'FormField',
  components: { HelpTip },
  props: {
    label: { type: String, default: '' },
    help: { type: String, default: '' },
    error: { type: String, default: '' },
    invalid: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.form-field {
  color: #374151;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  gap: 6px;
}

.field-label {
  align-items: center;
  display: flex;
  gap: 5px;
  font-weight: 600;
}

.form-field-error {
  color: #dc3545;
  font-size: 13px;
  margin-top: 2px;
}

.form-field :deep(input:not([type='checkbox'])),
.form-field :deep(select),
.form-field :deep(textarea) {
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-sizing: border-box;
  color: #111827;
  font-size: 14px;
  padding: 10px;
  width: 100%;
}

.form-field :deep(input:not([type='checkbox']):focus),
.form-field :deep(select:focus),
.form-field :deep(textarea:focus) {
  border-color: rgba(79, 70, 229, 0.6);
  outline: none;
}

.form-field :deep(input.invalid),
.form-field :deep(select.invalid),
.form-field :deep(textarea.invalid) {
  border-color: #dc3545;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.15);
}

.form-field :deep(input[type='checkbox']) {
  height: 18px;
  width: 18px;
  cursor: pointer;
}

.form-field :deep(.date-input-wrap),
.form-field :deep(.date-input) {
  width: 100%;
}
</style>
